<div class="permit_listing_page">
    <div class="col-md-12" *ngIf="isLoading">
      <app-busy [message]="message"></app-busy>
    </div>
  
    <div class="col-1 btn-show">
        <span
          title="Apply filters..."
          id="btnSearch"
          
          (click)="onSearch()"
          class="btn btn_primary btn-md"
          style="margin-right: 4px !important;display: none;"
          ><i class="fa fa-search" aria-hidden="true" ></i
        ></span>
       
        <span
          (click)="onReset()"
          title="Reset filters..."
          id="resetMonthlyComplianceFilter"
          class="btn btn_primary btn-md"
          style="margin-right: 4px !important;display: none;"
  
          ><i class="fa fa-undo" aria-hidden="true"></i
        ></span>
      </div>
  
      
    <ng-container>
      <div class="page_header">
        <h1 class="heading">Monthly Compliance Summary</h1>
      </div>
      <ng-container>
        <app-filter
          [formConfig]="filterConfig"
          [selectedItems]="selectedItems"
          (formValueChanged)="applyFilter($event)"
        ></app-filter>
      </ng-container>
   
      <div class="table-responsive" >
        <table class="table custom_table">
          <thead>
          
            <th>Account Number</th>
            <th>Account Name</th>
            <th>Status</th>
            <th>Lead User</th>
            <th>Account Type</th>
            <th *ngFor="let month of months">{{ month }}</th>
          </thead>
          <tbody>
            <tr
              class="tbl-row"
              *ngFor="
                let item of permits
                  | orderBy : criteria : direction
                  | paginate
                    : {
                        itemsPerPage: pageSize,
                        currentPage: utility.page,
                        totalItems: count
                      };
                let index = index
              "
            >
              <!-- <td class="bfr-end-col"><input  value="{{item.id}}" [ngModel]="selectedIndex === index"
                        (change)="CheckedCarrier($event,item.id,item,index)"></td> -->
            
              <td class="bfr-end-col">
                <a
                 
                  ><span title="">{{ item.AccountNumber }}</span></a
                >
              </td>
              <td class="bfr-end-col" title="{{ item.Name }}">{{ item.Name }}</td>
              <td class="bfr-end-col">
                {{ item.Status }}
              </td>
               <td class="bfr-end-col">{{item.LeadUser}}</td>
                    <td class="bfr-end-col">{{item.PermitType}}</td>
             
              <!-- <td class="bfr-end-col text-center">{{item.permit_num}}</td> -->
              <!-- <td class="bfr-end-col">{{ item.PermitType }}</td> -->
              <td *ngFor="let month of months" class="bfr-end-col text-center" style="text-align: center !important">
                <ng-container>
                  <td *ngIf="hasMonthlyData(item, month);">
                    <a (click)="navigate(item.carrier_id)" style="color: #00008b; text-decoration: underline">
                      <span title="View Monthly Compliance">{{ item.NumPermits }} / {{ getMonthlyTrips(item, month) }}</span>
                    </a>
                  </td>
                  <td *ngIf="!hasMonthlyData(item, month)">
                    <a (click)="navigate(item.carrier_id)" style="color: #00008b; text-decoration: underline">
                      <span title="View Monthly Compliance">{{ item.NumPermits }} / 0</span>
                    </a>
                  </td>
                </ng-container>
              </td>
              
            
             
              <!-- <td style="align-items: center;"> <img src="../../../assets/newimg/folder-dublicate-fill@2x.svg" class="process" /> -->
            </tr>
          </tbody>
          <tfoot>
            <tr  class="pagination_row">
              <td colspan="12" class="rm-brd">
                <div class="row">
                  <div class="col-2">
                    <div
                      class="input-group mb-3 rm-brd"
                      style="width: 125px !important; height: 30px !important"
                    >
                      <div class="input-group-prepend">
                        <label
                          class="input-group-text form-control-sm show-h"
                          for="show-id"
                          >Show:</label
                        >
                      </div>
                      <select
                        class="form-control form-control-sm show-h"
                        id="show-id"
                        [(ngModel)]="pageSize"
                  (change)="onChange(pageSize)"
                      >
                        <option
                          *ngFor="let key of utility.pageItems"
                          [ngValue]="key"
                        >
                          {{ key }}
                        </option>
                      </select>
                    </div>
                  </div>
                  <div class="col-10" *ngIf="!isAppliedFilter">
                    <pagination-controls
                      (pageChange)="utility.page = onNextOrPrevious($event)"
                      style="margin-right: 0px !important; float: right !important"
                    ></pagination-controls>
                  </div>

                  <div class="col-10" *ngIf="isAppliedFilter">
                    <pagination-controls
                      (pageChange)="utility.page = onNext($event)"
                      style="margin-right: 0px !important; float: right !important"
                    ></pagination-controls>
                  </div>
                </div>
              </td>
            </tr>
            <tr *ngIf="isFilteredDataEmpty">
              <td colspan="4" class="rm-brd">
                <span class="text-info text-small"
                  >No permit applications found.</span
                >
              </td>
            </tr>
          </tfoot>
        </table>
      </div>